import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import {
  CollectionRecord,
  Enums,
  HuntPackageRecord,
  ThreatProfile,
} from '@cyborg-monorepo/hunter/common';
import { map, Observable } from 'rxjs';
import { gatherTags } from '../../../../helpers/utils';
import { CollectionService } from '../../../research/services/collection.service';
import { SearchStateService } from '../../../research/services/search-state.service';
import {
  CyborgRouterSearchLink,
  SearchUrlService,
} from '../../../research/services/search-url.service';
import { ThreatProfileService } from '../../services/threat-profile.service';
import { FacetButtonItem } from '../facet-buttons/facet-buttons.component';

@Component({ standalone: false, 
  selector: 'cyborg-hunt-package-overview',
  templateUrl: './hunt-package-overview.component.html',
  styleUrls: ['./hunt-package-overview.component.scss'],
})
export class HuntPackageOverviewComponent implements OnInit {
  @Input() public data: HuntPackageRecord;
  public tags: FacetButtonItem[];
  public threatProfiles$: Observable<Array<ThreatProfile>>;
  public relatedCollections$: Observable<Array<CollectionRecord>>;

  public searchLink: Observable<CyborgRouterSearchLink>;

  public mitres = [];
  public mitreAttackTactic: string;
  public deepDive: SafeResourceUrl;

  constructor(
    private threatProfileService: ThreatProfileService,
    private sanitizer: DomSanitizer,
    private collectionService: CollectionService,
    public searchStateService: SearchStateService,
    private searchUrlService: SearchUrlService,
    private router: Router,
  ) {}

  public ngOnInit(): void {
    this.getDetails();
    this.getRelatedCollections();
  }

  private getDetails(): void {
    if (this.data?.context?.threat_names?.length > 0) {
      this.getThreatProfile(this.data);
    }
    this.tags = gatherTags(this.data);

    if (this.data?.references?.deep_dives?.length > 0) {
      const regexp = /\?v=(?<videoId>.*)/;
      const deepDiveFormated =
        this.data.references.deep_dives[0].match(regexp).groups.videoId;
      this.deepDive = this.sanitizer.bypassSecurityTrustResourceUrl(
        `https://www.youtube.com/embed/${deepDiveFormated}`,
      );
    }

    this.mitreAttackTactic = this.data?.mapping?.mitre?.mitre_attack_tactics
      .toString()
      .replace(',', ', ');

    this.mitres = [];
    for (
      let i = 0;
      i < this.data.mapping.mitre.mitre_attack_techniques.length;
      i += 1
    ) {
      const mitre = { technique: '', id: '' };
      mitre.technique = this.data.mapping.mitre.mitre_attack_techniques[i];
      mitre.id = this.data.mapping.mitre.mitre_attack_technique_ids[i];
      this.mitres.push(mitre);
    }
  }

  private getThreatProfile(huntPackage: HuntPackageRecord): void {
    this.threatProfiles$ =
      this.threatProfileService.getThreatProfilebyThreatName(huntPackage);
  }

  private getRelatedCollections(): void {
    this.relatedCollections$ =
      this.collectionService.getRelatedCollectionsByHuntPackageUUID(
        this.data.UUID,
      );
  }

  public navigateToCollection(collection: string): void {
    this.searchStateService.reset();
    this.searchStateService.setLibrary(
      [Enums.CyborgIndexEnum.CYBORG_COLLECTIONS],
      true,
    );
    this.searchStateService.setTerm(collection);

    const searchLink: CyborgRouterSearchLink =
      this.searchUrlService.stateToRouterLink(
        this.searchStateService.state.getValue(),
      );
    this.searchLink = this.searchStateService.state.pipe(
      map((state) => this.searchUrlService.stateToRouterLink(state)),
    );

    this.router.navigate(searchLink.routerLink as string[], {
      queryParams: searchLink.queryParams,
    });
  }
}
